import _ from 'underscore';
import { useCallback } from 'react';
import useSwr from 'swr';

import {
  fetchGridData,
} from '@bingads-webui-campaign/overview-cards-common';
import {
  TMajorMetric,
} from '@bingads-webui-campaign-react/overview-performance-table';
import { cardTopKeywordsId } from '@bingads-webui-campaign/fluent-page-consts';

export interface IUseGridDataProps {
  dateRange: {
    RangeStartDate: string;
    RangeEndDate: string;
    compared: object;
  },
  filter: {
    filter: {
      key: number;
      value: object;
    }
  }[],
  constructOptions: (navigationLevel?: string) => { entitySet: object };
  permissions: any;
  jsdata: any;
  dateUtil: any;
  orderby: string | number;
  direction: number;
  selectedMenuItem: TMajorMetric;
  columns: string[];
  cardTypeId: string;
  willFetchData: Function;
  willRender: Function;
  navigationLevel: string;
}

export function useGridData({
  dateRange,
  filter,
  constructOptions,
  permissions,
  jsdata,
  dateUtil,
  orderby,
  direction,
  selectedMenuItem,
  columns,
  cardTypeId,
  willFetchData,
  willRender,
  navigationLevel,
}: IUseGridDataProps) {
  const {
    entitySet,
  } = constructOptions(navigationLevel);

  const fetch = useCallback(({
    dateRange, filter, orderby, direction, selectedMenuItem, columns, cardTypeId,
  }) => {
    willFetchData();
    return fetchGridData({
      entitySet,
      dateRange,
      options: {
        orderby,
        direction,
        selectedMenuItem,
        columns,
      },
      filter,
      jsdata,
      dateUtil,
      permissions,
      dfmCacheKey: cardTypeId,
    }).then((values) => {
      willRender();
      return values.map((value) => {
        let keywordText;
        if (cardTypeId === cardTopKeywordsId) {
          keywordText = value.Text;
          if (value.MatchType === 'Phrase') {
            keywordText = `"${value.Text}"`;
          } else if (value.MatchType === 'Exact') {
            keywordText = `[${value.Text}]`;
          }
        }
        return {
          ...value,
          Name: keywordText || value.Text || value.Name,
          Id: value.Id || _.uniqueId(),
        };
      });
    });
  }, [dateUtil, entitySet, jsdata, permissions, willFetchData, willRender]);

  const { data, isLoading } = useSwr({
    dateRange, filter, orderby, direction, selectedMenuItem, columns, cardTypeId,
  }, fetch, {
    revalidateOnFocus: false,
  });

  return {
    data,
    isLoading,
  };
}
